import { useEffect, useReducer } from 'react';

export function fmtElapsed(sec) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

// Elapsed seconds from SERVER timestamps. `startedAt`/`finishedAt` are server
// ISO strings (or null). Ticks every second while `active` and not yet finished;
// once `finishedAt` is set the value is FROZEN to the exact server duration
// (so it never grows on re-render / pressing Download). Remount-proof: re-mounting
// with the same server `startedAt` continues the same count (no reset).
export function useElapsedSeconds(startedAt, finishedAt, active) {
  const [, tick] = useReducer((x) => x + 1, 0);
  const ticking = Boolean(active && startedAt && !finishedAt);
  useEffect(() => {
    if (!ticking) return undefined;
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [ticking]);
  if (!startedAt) return 0;
  const start = new Date(startedAt).getTime();
  if (!Number.isFinite(start)) return 0;
  const end = finishedAt ? new Date(finishedAt).getTime() : Date.now();
  return Math.max(0, Math.floor((end - start) / 1000));
}
